import React from 'react';

export default function ActivityPanel({ activities = [] }){
  return (
    <div className="bg-white rounded-2xl p-4 border">
      <h4 className="font-medium mb-3">Atividade recente</h4>
      <div className="space-y-3">
        {activities.map(a => (
          <div key={a.id} className="flex items-start justify-between">
            <div>
              <div className="font-medium">{a.title}</div>
              <div className="text-xs text-gray-500">{a.by} · {a.at}</div>
            </div>
            <div className="text-sm text-gray-400">›</div>
          </div>
        ))}
      </div>
      <div className="mt-4 text-center">
        <button className="text-sm text-purple-600">Ver histórico completo</button>
      </div>
    </div>
  );
}
